import React, { useState } from 'react';
import { API, authFetch } from '../utils/api';

// 말소대행 장부 탭 줄(월별 정산표|일별|주별 옆) — 그 달만 세금계산서 발행 여부를 바꾸는 스위치 (W2, 9/17 위치 이동+토글 디자인).
// 서버 계약(S2 동시 구현):
//   GET /work-units/:id/tax-month/:month → {issue,source,locked,preview:{rowCount,vatNow,vatIfOn,vatIfOff}}
//   PUT /work-units/:id/tax-month {month,issue} → {success,changed,vatDelta}; 409 = 발행돼 잠김
// taxMonth 가 없으면(구 서버 미배포 폴백) 아무것도 그리지 않는다 — 정산 GET 이 기존 issueTaxInvoice 로 표시.
var fmt = function (n) { return (parseInt(n) || 0).toLocaleString(); };

export default function TaxMonthSwitch(props) {
  var unitId = props.unitId, month = props.month, taxMonth = props.taxMonth;
  var onChanged = props.onChanged, showToast = props.showToast;
  var [busy, setBusy] = useState(false);

  if (!taxMonth) return null;

  var toast = function (msg, kind) { if (showToast) showToast(msg, kind); };
  var monthNo = parseInt((month || '').slice(5), 10) || 0;
  var issue = !!taxMonth.issue, locked = !!taxMonth.locked, source = taxMonth.source;

  var applyChange = function (next) {
    setBusy(true);
    authFetch(API + '/work-units/' + unitId + '/tax-month', {
      method: 'PUT', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ month: month, issue: next ? 1 : 0 }),
    }).then(function (r) { return r.json().then(function (d) { return { status: r.status, data: d }; }); })
      .then(function (res) {
        setBusy(false);
        var d = res.data || {};
        if (res.status === 409) { toast(d.error || '발행돼 잠겨 변경할 수 없습니다', 'err'); if (onChanged) onChanged(); return; }
        if (!d.success) { toast(d.error || '변경 실패', 'err'); return; }
        toast((d.changed || 0) + '건 반영');
        if (onChanged) onChanged();
      }).catch(function () { setBusy(false); toast('서버 오류', 'err'); });
  };

  var toggle = function () {
    if (locked || busy) return;
    setBusy(true);
    authFetch(API + '/work-units/' + unitId + '/tax-month/' + month).then(function (r) { return r.json(); }).then(function (d) {
      setBusy(false);
      var pv = (d && d.preview) || {};
      var next = !issue;
      var vatNow = pv.vatNow || 0;
      var target = next ? (pv.vatIfOn || 0) : (pv.vatIfOff || 0);
      var delta = target - vatNow;
      var msg = monthNo + '월 청구 ' + (pv.rowCount || 0) + '건 · 세액 ' + fmt(vatNow) + '원 → ' + fmt(target) + '원'
        + ' (차이 ' + (delta >= 0 ? '+' : '-') + fmt(Math.abs(delta)) + '원)'
        + '. 이 달만 적용되고 다음 달은 기본값으로 돌아갑니다.';
      if (!window.confirm(msg)) return;
      applyChange(next);
    }).catch(function () { setBusy(false); toast('조회 실패', 'err'); });
  };

  var disabled = locked || busy;
  return (<span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, whiteSpace: 'nowrap',
      border: '1px solid #e2e8f0', borderRadius: 999, padding: '4px 10px 4px 12px', background: '#fff' }}
      title={locked ? '발행됨 — 취소 후 변경' : (source === 'default' ? '거래처 기본값' : '이 달만 설정')}>
    <span style={{ fontSize: 13, fontWeight: 700, color: '#1e293b' }}>{monthNo}월 계산서 발행</span>
    <span role="switch" aria-checked={issue} aria-disabled={disabled}
      onClick={function () { if (!disabled) toggle(); }}
      style={{ position: 'relative', width: 46, height: 24, borderRadius: 12, flexShrink: 0,
        background: issue ? '#1e40af' : '#cbd5e1', cursor: disabled ? 'default' : 'pointer',
        opacity: locked ? 0.5 : (busy ? 0.6 : 1) }}>
      <span style={{ position: 'absolute', top: 2, left: issue ? 24 : 2, width: 20, height: 20, borderRadius: '50%',
        background: '#fff', boxShadow: '0 1px 2px rgba(0,0,0,.25)' }} />
      <span style={{ position: 'absolute', top: 0, bottom: 0, display: 'flex', alignItems: 'center',
        left: issue ? 6 : 'auto', right: issue ? 'auto' : 6, fontSize: 10, fontWeight: 700,
        color: issue ? '#fff' : '#475569' }}>{issue ? 'ON' : 'OFF'}</span>
    </span>
    {locked
      ? <span style={{ fontSize: 11, color: '#94a3b8' }}>발행완료·잠김</span>
      : <span style={{ fontSize: 13, fontWeight: 700, color: issue ? '#1e40af' : '#64748b' }}>{issue ? '발행' : '미발행'}</span>}
  </span>);
}
